export default __webpack_public_path__ + "static/ueber-uns-969f84418f80cf420e0a952854b89bae.webp";